import { EditableField } from '../../../../commonComponents/EditableField';
import { FormField } from '../../shared/FormField';
import { formatDate } from '../../shared/utils';

export const ExperienceField = ({
  experiences = [],
  experiencesForm = [],
  isEditing,
  onChange,
}) => {
  const isCurrentEmployer = (index) => index === 0 && experiencesForm?.[index]?.isCurrentEmployer;

  return (
    <EditableField
      editing={isEditing}
      view={
        experiences?.length
          ? experiences.map((experience, index) => (
              // eslint-disable-next-line react/no-array-index-key
            <div key={`experience-${index}`} className="mt-5">
              <span className="f-16 bold">Employer {index + 1}</span>
              <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '24px',
                    gap: '20px',
                  }}
                >
                <span className="f-16">Position Title: {experience.title}</span>
                <span className="f-16">Employer Name: {experience.employerName}</span>
                <span className="f-16">
                  Start Date: {formatDate(experience.startDate, 'M/D/YYYY')}
                </span>
                <span className="f-16">
                  End Date:{' '}
                  {experience.isCurrentEmployer ? (
                    <span>
                      Present <span style={{ fontStyle: 'italic' }}>(current)</span>
                    </span>
                    ) : (
                      formatDate(experience.endDate, 'M/D/YYYY')
                    )}
                </span>
              </div>
            </div>
            ))
          : '-'
      }
      // always populate 3 experiences in edit mode
      edit={Array.from({ length: 3 }, (_, index) => (
        <div key={`edit-experience-${index}`} style={{ marginTop: '24px' }}>
          <span className="f-16 bold">Employer {index + 1}</span>
          <FormField label="Title" style={{ marginTop: 18 }}>
            <input
              className="form-control"
              style={{ width: '500px' }}
              type="text"
              value={experiencesForm?.[index]?.title || ''}
              onChange={(e) => onChange(index, 'title', e.target.value)}
            />
          </FormField>
          <FormField label="Office Name" style={{ marginTop: 18 }}>
            <input
              className="form-control"
              style={{ width: '500px' }}
              type="text"
              value={experiencesForm?.[index]?.employerName || ''}
              onChange={(e) => onChange(index, 'employerName', e.target.value)}
            />
          </FormField>
          {index === 0 && (
            <div
              onClick={() =>
                onChange(index, 'isCurrentEmployer', !experiencesForm?.[index]?.isCurrentEmployer)
              }
              style={{
                display: 'flex',
                width: 'fit-content',
                alignItems: 'center',
                marginTop: 8,
                cursor: 'pointer',
                gap: 8,
              }}
            >
              <input
                type="checkbox"
                checked={experiencesForm?.[index]?.isCurrentEmployer || false}
                readOnly
                style={{ pointerEvents: 'none', margin: 0 }}
              />
              <p className="f-15" style={{ marginBottom: 0 }}>
                Present Position
              </p>
            </div>
          )}
          <div style={{ display: 'flex', marginTop: 18, gap: 18 }}>
            <FormField label="Start Date" style={{ width: '150px' }}>
              <input
                className="form-control"
                type="date"
                value={formatDate(experiencesForm?.[index]?.startDate)}
                onChange={(e) => onChange(index, 'startDate', e.target.value)}
              />
            </FormField>
            <FormField label="End Date" style={{ width: '150px' }}>
              <input
                className="form-control"
                type={isCurrentEmployer(index) ? 'text' : 'date'}
                value={
                  isCurrentEmployer(index)
                    ? 'Present'
                    : formatDate(experiencesForm?.[index]?.endDate)
                }
                disabled={isCurrentEmployer(index)}
                onChange={(e) => onChange(index, 'endDate', e.target.value)}
              />
            </FormField>
          </div>
        </div>
      ))}
    />
  );
};
